import CustomUvVariants from "./custom_uv_variants_vert.glsl.js";
import CustomUvVariantsPars from "./custom_uv_variants_pars_vert.glsl.js";
/* eslint-disable import/no-anonymous-default-export */
export default /* glsl */`
#define STANDARD

varying vec3 vViewPosition;

varying vec3 vWorldPosition;
attribute vec3 anisotropicTangent;
varying vec3 vAnisotropicTangent;
uniform bool uv2AlphaMap;

#ifndef FLAT_SHADED

	varying vec3 vNormal;

	#ifdef USE_TANGENT

		varying vec3 vTangent;
		varying vec3 vBitangent;

	#endif

#endif

#include <common>
#include <uv_pars_vertex>
${CustomUvVariantsPars}
// #include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {

	#include <uv_vertex>
	${CustomUvVariants}
	//#include <uv2_vertex>
	#include <color_vertex>

	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>

#ifndef FLAT_SHADED // Normal computed with derivatives when FLAT_SHADED

	vNormal = normalize( transformedNormal );

	#ifdef USE_TANGENT

		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );

	#endif

#endif

	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>

	vViewPosition = - mvPosition.xyz;

	//TODO: wrap these in ifdefs
	// the bases for these can be found basically in the normal calculations
	vAnisotropicTangent = normalize(normalMatrix * anisotropicTangent.xyz);
	

	#include <worldpos_vertex>
	
	#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP )
		vWorldPosition = worldPosition.xyz;
  	#endif

	#include <shadowmap_vertex>
	#include <fog_vertex>


}
`;